import { Component, OnInit, Output, EventEmitter,Input } from '@angular/core';

@Component({
	selector: 'button-icon',
	templateUrl: './button-icon.component.html',
	styleUrls: ['./button-icon.component.scss'],
})
export class ButtonIconComponent implements OnInit {
	@Output() eventClick = new EventEmitter<any>();
	@Input() disable: boolean;

	constructor() 
	{
		// This is intentional
	}

	ngOnInit(): void 
	{
		// This is intentional
	}

	icon() {
		this.eventClick.emit();
	}
}
